import { render } from "./UserTable.vue?vue&type=template&id=15d523bc&scoped=true&ts=true"
import script from "./UserTable.vue?vue&type=script&lang=ts"
export * from "./UserTable.vue?vue&type=script&lang=ts"

import "./UserTable.vue?vue&type=style&index=0&id=15d523bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d523bc"]])

export default __exports__